import * as React from 'react';
import { Layout } from '../Layout';
import { VerticalSlider } from '../VerticalSlider';
import * as styles from './InstagramSection.css';

interface IInstagramSectionProps {
  title: React.ReactNode;
  cards: React.ReactNode;
}

export function InstagramSection({ title, cards }: IInstagramSectionProps) {
  return (
    <section id="instagram" className={styles['instagram']}>
      <Layout>
        <div className={styles['instagram__title']}>{title}</div>

        <VerticalSlider>{React.Children.map(cards, card => card)}</VerticalSlider>
      </Layout>
    </section>
  );
}
